import state from './../state';
import {getHash, proxy, cloneObject} from './../functions';
import SimpleEvent from './../event';
import Responder from './../responder';

class StateNavigation extends Responder{

    constructor(properties, model=null){
        super();

        this.hasPushState = ('pushState' in window.history);
        // if(! this.hasPushState){
        //     return;
        // }
        this.event = null;

        // if(this.hasPushState){
        //     this.event = new SimpleEvent(window, 'popstate', [this, this.onPopState]);
        // }

        this.properties = properties;
        
        this.model = null;
        if(model){
            this.model = model;
            this.addListener(this.model, [this, this.onRetrieveState]);
        }

        this.state = {};
        for( let [key, value] of this.properties) {
            this.addListener(state, [this, this.onStateChange], key, value);
            this.state[key] = value;
        }
        
        this.currentKey = '';
        this.stateJSON = JSON.stringify(this.state);
        
        this.onPopState();

        this.intervalTimer = setInterval(proxy([this, this.checkHash]), 1000);
        this.timerId = null;

        this.currentPage = null;
    }

    /*  less then ideal, this is checking the hash every second. This is because in
        IE changing the url in the address bar will not trigger hashchange or popstate */
    checkHash(){
        let hash = window.location.hash? window.location.hash.substring(1): '';
        if(hash != this.currentKey){
            this.onPopState();
        }
    }

    remove(){
        clearTimeout(this.timerId);
        clearInterval(this.intervalTimer);
        if(this.event){
            this.event.remove();
        }
        super.remove();
        this.model = null;
        this.properties = null;
        this.state = null;
    }

    onStateChange(){
        clearTimeout(this.timerId);
        this.timerId = setTimeout(proxy([this, this.pushState]), 500);
    }

    pushState(){
        let newState = {};
        for(let [key, value] of this.properties) {
            newState[key] = state.get(key);
        }
        let stateJSON = JSON.stringify(newState);
        if(stateJSON != this.stateJSON){
            this.stateJSON = stateJSON;
            this.state = cloneObject(newState);
            
            if(this.model){
                this.model.save(this.stateJSON);
            }else{
                let key = '#' + getHash(stateJSON);
                if(key != this.currentKey){
                    if(this.hasPushState){
                        window.history.pushState(cloneObject(this.state), '', key);
                    }else{
                        window.location.hash = key;
                    }
                    this.currentKey = (key.length>1)? key.substring(1): '';
                }
            }
        }

    }

    onRetrieveState(){

        if(this.model.status == 'success'){
            let data = this.model.data;
            if(data.type == 'save'){
                // we saved the state object and in reponse is the matching hash
                if(data.state == this.stateJSON && data.hash != this.currentKey){
                    let state = JSON.parse(data.state);
                    this.currentKey = data.hash;
                    if(this.hasPushState){
                        window.history.pushState(cloneObject(state), '', '#' + data.hash);
                    }else{
                        window.location.hash = '#' + data.hash;
                    }
                }
            }else{
                // we loaded from a hash and in the response is the matching state object
                if(data.hash == this.currentKey){
                    // clearTimeout(this.timerId);
                    let stateObj = JSON.parse(data.state);

                    this.state = {};
                    // looping over this.properties and not the return state object ensures
                    // we end up with a this.stateJSON in the same format (same properties
                    // AND in the same order)
                    for(let [key, value] of this.properties) {
                        if(stateObj[key]){
                            this.state[key] = cloneObject(stateObj[key]);
                        }else{
                            this.state[key] = null;
                        }
                        // first reset the state value: the filter model will reset any child values when 
                        // a parent value is removed. This means if only the child value is given here it
                        // will be resetted because the parent value is not there. This is a bit of a 
                        // workaround for now, should give some more thought to this issue.
                        state.set(key, null); 
                        state.set(key, stateObj[key]);
                    }
                    this.stateJSON = JSON.stringify(this.state);
                }
                
            }
        }

    }

    onPopState(event){
        let hash = window.location.hash? window.location.hash.substring(1): '';

        let cleanHash = hash; //this.cleanHash(hash);
        if(cleanHash == this.currentKey){
            return;
        }
        clearTimeout(this.timerId);
        this.currentKey = cleanHash;

        if(event && event.state){
            for(let key of Object.keys(event.state)){
                this.state[key] = cloneObject(event.state[key]);
                state.set(key, event.state[key]);
            }
            this.stateJSON = JSON.stringify(this.state);
        }else{
            // todo: show loader
            if(this.model){
                this.model.load(hash);
            }else{
                // can't load anything, reset the hash
                window.location.hash = '';
            }
        }
    }

    // make sure there are not parameters, just the hash value -> why did we need to do this..?
    // probably if a combination of hash followed by other params occur
    cleanHash(dirty){
        let p = dirty.split('&');
        if(p[0].indexOf('=') !== -1){
            let hash = p[0].split('=');
            // it looks like first param is a hash, return it
            if(hash.length == 1){
                return hash[0];
            }
            // there's only parameter, no hash
            return ''; //dirty;
        }
        // there is a hash
        return p[0];
    }

}

export default StateNavigation;